// Copyright (c) 2023, iPivot, Corp.
'use strict'

const axios = require('axios')
const { getTheme, imageUrl, resolveTheme } = require('@ipivot/themes-base')

module.exports.availableThemes = async () => {
    const availableThemesFromRegistry = (await axios.get('/themes')).data

    if (availableThemesFromRegistry.length === 0) {
        availableThemesFromRegistry.push('default')
    }

    return availableThemesFromRegistry.map(theme => getTheme(theme))
}

module.exports.getDefaultTheme = async () => {
    return resolveTheme(await module.exports.availableThemes(), {})
}

// Re-exported so browser code has one themes import rather than reaching past this
// package into themes-base.
module.exports.resolveTheme = resolveTheme

module.exports.getImage = imageId => {
    return `${module.exports.imageUrl}/${imageId}`
}

module.exports.imageUrl = imageUrl
